import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { Config } from './config';
import { BatteryStatusList, BatteryStatusListResponse, BatteryStatusReportArgs } from '../models/battery-status';
import { BatteryTotalCount } from '../models/battery-total-count';
import { map } from 'rxjs/operators';

@Injectable()
export class BatteryStatusService {
    constructor(public http: HttpClient, public authService: AuthService) {}

    public getBatteryStatus(params: BatteryStatusReportArgs) {
        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach(function (key) {
            if (key === 'Sort' || key === 'StartPage' || key === 'PageSize' || key === 'SearchValue') {
                httpParams = httpParams.append('Paging.' + key, params[key].toString());
                return;
            }
            if (key !== 'LocationGroupID') {
                httpParams = httpParams.append(key, params[key]);
            }
        });

        if (params.LocationGroupID > 0) {
            httpParams = httpParams.append('LocationGroupID', params.LocationGroupID.toString());
        }

        return this.http.get<BatteryStatusListResponse>(Config.urls.batteryStatusUrl, { params: httpParams }).pipe(
            map((res) => {
                if (res) {
                    return <BatteryStatusList>{
                        batteryStatusList: res.listBatteries,
                        batteryGraphStatusList: res.listBatteriesStatus,
                        count: res.count,
                    };
                } else {
                    return null;
                }
            }),
        );
    }

    public getBatteryStatusTotal(params: BatteryStatusReportArgs): Observable<BatteryTotalCount> {
        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach(function (key) {
            if (key !== 'LocationGroupID') {
                httpParams = httpParams.append(key, params[key]);
            }
        });

        if (params.LocationGroupID > 0) {
            httpParams = httpParams.append('LocationGroupID', params.LocationGroupID.toString());
        }

        return this.http.get<BatteryTotalCount>(Config.urls.batteryStatusTotalUrl, { params: httpParams });
    }
}
